<template>
  <el-dialog title="手机号验证" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false" :close-on-press-escape="false" class="phone-dialog" @close="handleClose">
    <div class="phone-dialog-content">
      <div class="phone-dialog-tip">
        为确保账号安全，请完成手机号验证 → 获取验证码
      </div>

      <div class="phone-form">
        <div class="phone-form-item">
          <label class="phone-form-label">手机号</label>
          <div class="phone-number-display" v-if="phoneState === 2">
            {{ phoneNumber }}
          </div>
          <div v-else class="phone-input-wrapper">
            <el-input v-model="currentPhoneNumber" placeholder="请输入手机号" size="small" class="phone-input" :disabled="phoneState === 2" @input="validatePhoneInput" :class="{ 'is-error': phoneError }">
              <template slot="suffix" v-if="currentPhoneNumber">
                <i class="el-icon-circle-close" @click="clearPhoneNumber"></i>
              </template>
            </el-input>
            <div v-if="phoneError" class="phone-error-tip">{{ phoneError }}</div>
          </div>
        </div>

        <div class="phone-form-item">
          <label class="phone-form-label">验证码</label>
          <div class="phone-verify-group">
            <el-input v-model="verifyCode" placeholder="输入验证码" size="small" class="verify-input">
              <el-button slot="suffix" type="text" size="small" @click="sendPhoneCode" style="height:100%" :disabled="codeCountdown > 0" class="send-code-btn">
                {{ codeCountdown > 0 ? `${codeCountdown}s` : '发送验证码' }}
              </el-button>
            </el-input>
          </div>
        </div>
      </div>
      <div class="btns">
        <el-button plain size="small" type="primary" @click="ignorePhone" class="ignore-btn">忽略</el-button>
        <el-button size="small" type="primary" @click="verifyPhone" :disabled="!verifyCode" class="verify-btn">
          立即验证
        </el-button>
      </div>

      <div class="phone-dialog-notes">
        <p>1. 为确保教师账号安全，请务必于9月1日前完成手机号验证流程</p>
        <p>2. 发送验证码后，您可以在手机短信中获取（5分钟内有效期）</p>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  api_tchSendSms,
  api_tchVerifyCode
} from '@/api/javaApi'
import { mapGetters } from 'vuex'

export default {
  name: 'PhoneVerifyDialog',
  props: {
    // 接收外部传入的手机验证状态
    phoneState: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      verifyCode: '',
      codeCountdown: 0,
      codeTimer: null,
      currentPhoneNumber: '', // 当前输入的手机号
      phoneError: '' // 手机号输入错误提示
    }
  },
  computed: {
    ...mapGetters('globalCheck', ['currentDialog']),
    phoneNumber() {
      return this.$store.state.user.userInfo.phoneNum || ''
    },
    userId() {
      return this.$store.state.user.userInfo.id
    }
  },
  watch: {
    // 监听全局检查系统的currentDialog状态
    currentDialog: {
      handler(newVal) {
        if (newVal === 'phone') {
          // 需要显示手机号验证弹框
          this.currentPhoneNumber = this.phoneNumber
          this.dialogVisible = true
        } else {
          // 不需要显示手机号验证弹框
          this.dialogVisible = false
        }
      },
      immediate: true
    },
    // 保持向后兼容，监听 phoneState 变化
    phoneState: {
      handler(newState) {
        if (newState === 0) {
          // 不需要校验，直接触发成功事件
          this.dialogVisible = false
          this.$emit('success')
        } else if (newState === 1 || newState === 2 || newState === 3) {
          // 需要弹窗，设置手机号并显示
          this.currentPhoneNumber = this.phoneNumber
          this.dialogVisible = true
        }
      },
      immediate: true
    }
  },
  methods: {
    // 添加手机号码格式校验函数
    validatePhoneNumber(phone) {
      // 中国大陆手机号码格式校验
      const phoneRegex = /^1[3-9]\d{9}$/
      if (!phone) {
        return { valid: false, message: '请输入手机号码' }
      }
      if (!phoneRegex.test(phone)) {
        return { valid: false, message: '请输入正确的手机号码格式' }
      }
      return { valid: true, message: '' }
    },

    validatePhoneInput() {
      const validation = this.validatePhoneNumber(this.currentPhoneNumber);
      if (!validation.valid) {
        this.phoneError = validation.message;
      } else {
        this.phoneError = '';
      }
    },

    clearPhoneNumber() {
      this.currentPhoneNumber = ''
      this.phoneError = ''
    },

    async sendPhoneCode() {
      const phone = this.phoneState === 2 ? this.phoneNumber : this.currentPhoneNumber
      console.log('发送验证码到:', phone)

      // 添加手机号校验
      const validation = this.validatePhoneNumber(phone)
      if (!validation.valid) {
        this.$message.warning(validation.message)
        return
      }

      this.sendCode(phone)
    },
    ignorePhone() {
      // 设置sessionStorage，本次登录期间不再弹出
      sessionStorage.setItem('updatePhoneStorage', 'false')
      this.dialogVisible = false
    },
    async verifyPhone() {
      if (!this.verifyCode) {
        this.$message.warning('请输入验证码')
        return
      }

      // 添加手机号校验
      const phone = this.phoneState === 2 ? this.phoneNumber : this.currentPhoneNumber
      const validation = this.validatePhoneNumber(phone)
      if (!validation.valid) {
        this.$message.warning(validation.message)
        return
      }

      try {
        console.log('验证码:', this.verifyCode)
        await api_tchVerifyCode({
          userId: this.userId,
          phone: phone,
          code: this.verifyCode,
        })
        this.$store.dispatch('freshUserData')
        this.$message.success('验证通过')
        // 设置sessionStorage，本次登录期间不再弹出
        sessionStorage.setItem('updatePhoneStorage', 'false')
        this.dialogVisible = false
        this.resetForm()
        this.$emit('success')
      } catch (error) {
        console.error('验证失败:', error)
        this.$emit('error', error)
      }
    },

    sendCode(phone) {
      // 使用新的校验函数替换原有的简单校验
      const validation = this.validatePhoneNumber(phone)
      if (!validation.valid) {
        this.$message.warning(validation.message)
        return
      }

      api_tchSendSms({
        phone: phone,
        userId: this.userId,
      }).then(() => {
        // 开始倒计时
        this.codeCountdown = 60
        this.codeTimer = setInterval(() => {
          this.codeCountdown--
          if (this.codeCountdown <= 0) {
            clearInterval(this.codeTimer)
            this.codeTimer = null
          }
        }, 1000)
        this.$message.success('验证码已发送')
      }).catch(error => {
        console.error('发送验证码失败:', error)
        this.$emit('error', error)
      })
    },

    handleClose() {
      // 设置sessionStorage，本次登录期间不再弹出
      sessionStorage.setItem('updatePhoneStorage', 'false')
      this.resetForm()
      this.$emit('close')
    },

    resetForm() {
      this.verifyCode = ''
      this.currentPhoneNumber = ''
      this.codeCountdown = 0
      this.phoneError = '' // 重置手机号错误提示
      if (this.codeTimer) {
        clearInterval(this.codeTimer)
        this.codeTimer = null
      }
    }
  },
  beforeDestroy() {
    if (this.codeTimer) {
      clearInterval(this.codeTimer)
    }
  }
}
</script>

<style lang="scss" scoped>
// 修改手机号弹框样式
/deep/ .phone-dialog {
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #e5e5e5;
  }

  .el-dialog__title {
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }

  .el-dialog__body {
    padding: 20px;
  }
}

.phone-dialog-content {
  .phone-dialog-tip {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
    line-height: 1.5;
  }

  .phone-form {
    .phone-form-item {
      margin-bottom: 20px;

      .phone-form-label {
        display: inline-block;
        width: 60px;
        font-size: 14px;
        color: #333;
        margin-right: 10px;
      }

      .phone-number-display {
        display: inline-block;
        font-size: 16px;
        color: #333;
        font-weight: 500;
      }

      .phone-input-wrapper {
        position: relative;
        display: inline-block;
        width: calc(100% - 70px);
        /deep/.el-input__suffix {
          display: flex;
          align-items: center;
          padding: 0 5px;
          .el-input__suffix-inner {
            .el-icon-circle-close {
              cursor: pointer;
              font-size: 14px;
              color: #c0c4cc;
              transition: color 0.3s;
              &:hover {
                color: #909399;
              }
            }
          }
        }
        .phone-input {
          width: 100%;

          &.is-error {
            /deep/ .el-input__inner {
              border-color: #f56c6c;
            }
          }
        }

        .phone-error-tip {
          position: absolute;
          top: 100%;
          left: 0;
          color: #f56c6c;
          font-size: 12px;
        }
      }

      .phone-verify-group {
        display: inline-block;
        width: calc(100% - 70px);

        .verify-input {
          width: 100%;

          /deep/ .el-input__inner {
            padding-right: 100px;
          }

          /deep/ .el-input__suffix {
            right: 10px;
          }
        }

        .send-code-btn {
          color: #409eff;
          font-size: 12px;
          padding: 0 10px;

          &:hover {
            color: #66b1ff;
          }

          &:disabled {
            color: #c0c4cc;
            cursor: not-allowed;
          }
        }
      }
    }
  }

  .btns {
    display: flex;
    justify-content: flex-end;
    margin: 20px 0;
    .ignore-btn {
      width: 100px;
      // &.el-button--primary.is-plain {
      //   background: #fff;
      // }
      // &.el-button--primary.is-plain:focus,
      // .el-button--primary.is-plain:hover {
      //   background: #409eff;
      // }
    }
    .verify-btn {
      width: 140px;
    }
  }

  .phone-dialog-notes {
    font-size: 12px;
    color: #999;
    line-height: 1.6;

    p {
      margin: 0 0 8px 0;
    }
  }
}
</style> 